/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { TextField } from "@mui/material";
import { useContentZoneContext } from "cms/components/context";
import { useUpdateComponent } from "cms/components/hooks/use-update-component";
import { SimplicityComposerEnsureTipTap } from "cms/rich-text/simplicity-composer-tiptap";
import LabelledField from "components/labelled-field";
import Config from "data/config";
import { useTranslation } from "react-i18next";
import ComponentGalleryEditWrapper from "./component-gallery-wrapper";
import { ImageGalleryItemEditor } from "./gallery-item";
import { SelectGalleryStyle } from "./select-gallery-style";
// import Config from 'data/config'

const ImageGalleryComponentEditor = () => {

    const { t } = useTranslation();
    const { defaultImpl } = useContentZoneContext();
    const { component, update, updateFactory } = useUpdateComponent();
    const {
        title,
        description,
        galleryType,
        image_gallery: imageGallery,
    } = component || {};

    const onChangeTitle = (event) => {
        const nextTitle = event.target.value;
        update("title", nextTitle);
    };

    const onChangeGalleryType = updateFactory("galleryType");
    const onChangeImageGalleryList = updateFactory("image_gallery");
    const onChangeDescription = updateFactory("description");

    return (
        <div className='simplicity-editor-frame'>

            {/*  Title  */}
            <LabelledField label={t("commons.title")}>
                <TextField
                    id='image_gallery_title'
                    fullWidth={true}
                    value={title}
                    onChange={onChangeTitle}
                />
            </LabelledField>


            {/*  Description  */}
            <LabelledField label={t("commons.description")}>
                <SimplicityComposerEnsureTipTap
                    richtext={description}
                    onChange={onChangeDescription}
                />
            </LabelledField>


            {/*  Type Buttons  */}
            <LabelledField label={t("Components.galleryTypes")}>
                <SelectGalleryStyle
                    galleryType={galleryType}
                    onChange={onChangeGalleryType}
                />
            </LabelledField>


            {/*  Gallery Images  */}
            <LabelledField label={t("Components.galleryImages")}>
                <ComponentGalleryEditWrapper
                    imageGallery={imageGallery}
                    onChange={onChangeImageGalleryList}
                    defaultImpl={defaultImpl}
                >
                    <ImageGalleryItemEditor />
                </ComponentGalleryEditWrapper>
            </LabelledField>
            {Config.Debug.useDebug && (
                <div>
                    <details>
                        <summary>LocalState</summary>
                        <pre style={{ fontSize: "9px", width: "800px", overflowX: "auto", backgroundColor: "#efefef" }}>
                            {JSON.stringify(component, null, 2)}
                        </pre>
                    </details>
                </div>
            )}
        </div>
    );
};
ImageGalleryComponentEditor.displayName = "ImageGalleryComponentEditor";
export { ImageGalleryComponentEditor };

